// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17 4H0V20H17V15.7232L24 19.7232V4.23382L17 8.43382V4ZM12 7V9H10V14.5C10 15.8807 8.88072 17 7.5 17C6.11929 17 5 15.8807 5 14.5C5 13.1193 6.11929 12 7.5 12C7.67123 12 7.83845 12.0172 8 12.05V7H12Z"}}]};

const VideoCameraMusicFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'video-camera-music-filled',
    ref,
    icon: element,
  },
));

VideoCameraMusicFilledIcon.displayName = 'VideoCameraMusicFilledIcon';

export default VideoCameraMusicFilledIcon;
